const EVENT_NAMES = {
  PageView: "PageView",
  Lead: "Lead",
  InitiateCheckout: "InitiateCheckout",
  Purchase: "Purchase",
};

const initialised = new Set();

// Meta's standard loader: a queueing fbq stub plus fbevents.js. No PageView here;
// the engine sends it per pixel.
function installFbq() {
  if (window.fbq) return;
  const fbq = function () {
    if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
    else fbq.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
}

const meta = {
  isValid: (pixel) => /^\d{10,20}$/.test(pixel.id),

  load(pixels) {
    installFbq();
    pixels.forEach(({ id }) => {
      if (initialised.has(id)) return;
      initialised.add(id);
      window.fbq("init", id);
    });
  },

  send(event, data, key, pixel) {
    const name = EVENT_NAMES[event];
    if (!name) return;
    const params = data.value != null ? { value: data.value, currency: data.currency } : {};
    // trackSingle: only this pixel receives it, never other pixels on the page.
    if (key) window.fbq("trackSingle", pixel.id, name, params, { eventID: key });
    else window.fbq("trackSingle", pixel.id, name, params);
  },
};

export default meta;
